import { FormManager } from "./form-manager";
import { ModalOption } from "../../helpers/modal-option";
import { Injectable, TemplateRef, RendererFactory2 } from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";
import {
  BsModalRef,
  BsModalService,
  ModalOptions,
  ComponentLoaderFactory
} from "ngx-bootstrap";

@Injectable({
  providedIn: "root"
})
export class ModalFormService extends BsModalService {
  private _suscriptions: Subscription[] = [];

  constructor(rendererFactory: RendererFactory2, clf: ComponentLoaderFactory) {
    super(rendererFactory, clf);
  }

  showComponent(component: any, options?: ModalOptions): FormManager {
    return this.show(component, options)
      .setComponentManager(false)
      .contentAsFormManager();
  }

  show(
    content: string | TemplateRef<any> | any,
    config?: ModalOptions
  ): ModalFormRef {
    const ref = super.show(content, config || new ModalOption());

    if (ref.content && ref.content.formLevel) {
      const level = super.getModalsCount();
      ref.content.formLevel = new FormLevel(level);

      ref.content.formLevel.setMaxLevelCallback(() => {
        return super.getModalsCount();
      });
    }

    return new ModalFormRef(ref);
  }

  subscribe(subscrition: Subscription) {
    this._suscriptions.push(subscrition);
  }

  unsubscribe() {
    this._suscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });

    this._suscriptions = [];
  }

  hide(level: number) {
    super.hide(level);
  }
}

export class ModalFormRef extends BsModalRef {
  hiddenCallback: Function;

  constructor(bsModalRef: BsModalRef) {
    super();
    Object.assign(this, bsModalRef);

    if (this.content) {
      this.content.modalFormRef = this;
    }
  }

  setCallback(callback: Function) {
    this.hiddenCallback = callback;
  }

  contentAsFormManager(): FormManager {
    return this.content;
  }

  setComponentManager(value: boolean) {
    this.content.hasComponentManager = value;

    return this;
  }
}

export class FormLevel {
  getMaxLevel: Function;
  level: number;

  constructor(level?: number) {
    this.level = level || 0;
  }

  setMaxLevelCallback(func?: Function) {
    this.getMaxLevel = func;

    return this;
  }

  isTopLevel(): boolean {
    const maxLevel = this.getMaxLevel ? this.getMaxLevel() : 0;

    return this.level === maxLevel;
  }
}
